"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    const reportError = async () => {
      try {
        const errorData = {
          error: {
            message: error.message,
            stack: error.stack,
            digest: error.digest,
          },
          timestamp: new Date().toISOString(),
          path: window.location.pathname,
          navigator: {
            userAgent: window.navigator.userAgent,
            language: window.navigator.language,
            cookieEnabled: window.navigator.cookieEnabled,
            online: window.navigator.onLine,
            screenResolution: {
              width: window.screen.width,
              height: window.screen.height,
            },
          },
        };

        await fetch("/api/report-error", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(errorData),
        });
      } catch (e) {
        console.error("Failed to report error:", e);
      }
    };

    reportError();
    //TODO: Update logic to correctly redirect when there is an error, SIM: https://taskei.amazon.dev/tasks/P235919787
  }, [error]);

  // You might want to render a user-friendly error message
  return null;
}
